import { connect } from 'react-redux'

import { createDateObject } from 'packages/utils/dateHelpers'

import { getActiveUserAssignmentByClean } from 'app/fieldapp/store/assignments/selectors'
import { Clean } from 'app/fieldapp/store/cleans'
import { fetchCleans } from 'app/fieldapp/store/cleans/actions'
import { getFrozenCleans } from 'app/fieldapp/store/cleans/selectors'
import { fetchActiveCleanTimesForUser } from 'app/fieldapp/store/cleantimes/actions'
import { fetchActiveOtherTimersForUser } from 'app/fieldapp/store/otherTimers/actions'
import { fetchActiveTicketTimesForUser } from 'app/fieldapp/store/ticket-times/actions/fetchActiveTicketTimesForUser'
import { fetchTickets } from 'app/fieldapp/store/tickets/actions'
import { getAuthUser, getActiveUser } from 'app/fieldapp/store/users/selectors'
import { fetchVisits } from 'app/fieldapp/store/visits/actions'
import { getVisitsOnDate } from 'app/fieldapp/store/visits/selectors'

import {
  FieldAppInitializer,
  FieldAppInitializerProps,
} from './FieldAppInitializer'

type ReduxSelectors =
  | 'getActiveUser'
  | 'getActiveUserAssignmentByClean'
  | 'getAuthUser'
  | 'getFrozenCleans'
  | 'getVisits'

type ReduxActions =
  | 'fetchCleanTimes'
  | 'fetchCleans'
  | 'fetchOtherTimers'
  | 'fetchTicketTimes'
  | 'fetchTickets'
  | 'fetchVisits'

type StateProps = Pick<FieldAppInitializerProps, ReduxSelectors>
type DispatchProps = Pick<FieldAppInitializerProps, ReduxActions>
type PassThruProps = Omit<
  FieldAppInitializerProps,
  ReduxSelectors | ReduxActions
>

const mapStateToProps = state => ({
  getActiveUser: () => getActiveUser(state),
  getActiveUserAssignmentByClean: (clean: Clean) =>
    getActiveUserAssignmentByClean(state, clean),
  getAuthUser: () => getAuthUser(state),
  getFrozenCleans: () => getFrozenCleans(state),
  getVisits: () => getVisitsOnDate(state, createDateObject()),
})

const mapDispatchToProps = (dispatch): DispatchProps => ({
  fetchCleans: (userId: string, startDate: string, endDate?: string) =>
    dispatch(fetchCleans(userId, startDate, endDate)),
  fetchCleanTimes: () => dispatch(fetchActiveCleanTimesForUser()),
  fetchOtherTimers: () => dispatch(fetchActiveOtherTimersForUser()),
  fetchTickets: (userId: string) => dispatch(fetchTickets(userId)),
  fetchTicketTimes: () => dispatch(fetchActiveTicketTimesForUser()),
  fetchVisits: (userId: string, date: string) =>
    dispatch(fetchVisits(userId, date)),
})

export const ConnectedFieldAppInitializer = connect<
  StateProps,
  DispatchProps,
  PassThruProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(FieldAppInitializer)
